import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import PulpoField from '../../../../pulpo_visualizer/fields';
import styles from '../steps.module.scss';
import TooltipWithHeading from '../../../../components/helpToolTip/ToolTip';

const Step1 = ({
  info,
  onInfoChange,
  handleFieldErrorChanged,
  showFormErrors,
  orderField,
  defaultFieldSchema,
  enableBadge,
  dataSchemaValue,
  selectedLang,
  airport_data
}) => {
  const getDescription = () => ((selectedLang && selectedLang !== '' && defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.description)
                ? defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.description
                : `${defaultFieldSchema?.[orderField]?.description || ''}`);

  return (
  <>
    {info.is_anonymous ? (
      <p />
    ) : (
      <>
      {orderField === 'default_reported_by' && (info?.contact_info || info?.badge_info) && (
        <>
          <div className={styles.title} style={{ borderBottom: selectedLang === 'az' ? '1px solid #2e406b' : '1px solid #E6EAEE',
          fontFamily: selectedLang === 'az' ? 'calibri' : 'lato'
           }}>
            {info.isAnonymous ? (
              <FormattedMessage
                tagName="h5"
                id="sms.step1.title"
                defaultMessage="Reported"
              />
            ) : (
              <div style={{ display: 'flex' }}>
              <FormattedMessage
                tagName="h5"
                id="sms.step1.titles"
                defaultMessage={(selectedLang && selectedLang !== '' && defaultFieldSchema?.default_reported_by?.meta_data?.[selectedLang]?.name)
                  ? defaultFieldSchema?.default_reported_by?.meta_data?.[selectedLang]?.name
                  : `${defaultFieldSchema?.default_reported_by?.title || 'Reported By'}`}
              />
              {defaultFieldSchema && defaultFieldSchema?.default_reported_by && defaultFieldSchema?.default_reported_by?.description?.length > 0 && (
                <TooltipWithHeading
                  title="Help"
                  toolTip={`form.setting.newfield.helptext.${defaultFieldSchema?.default_reported_by?.description}`}
                  text={getDescription()}
                  values={getDescription()}
                  iconStyles={styles.helpTooltip}
                />
              )}
              </div>
            )}
          </div>
          {info?.contact_info && (
            <>
              <PulpoField
                key="firstName"
                id="firstName"
                type="string"
                translationID="hazard.firstName"
                title="First Name"
                isRequired={!dataSchemaValue?.name}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                answer={info?.firstName}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged} />
              <PulpoField
                key="lastName"
                id="lastName"
                type="string"
                translationID="hazard.lastName"
                title="Last Name"
                isRequired={!dataSchemaValue?.last_name}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                answer={info?.lastName}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged} />
              <PulpoField
                key="email"
                id="email"
                type="string"
                translationID="hazard.email"
                title="Email"
                isRequired={!dataSchemaValue?.email}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                answer={info?.email}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged} />
              <PulpoField
                key="phone"
                id="phone"
                type="telephone"
                translationID="hazard.phone"
                title="Phone"
                onlyDefaultCountryCode
                isRequired={!dataSchemaValue?.phone}
                handleValueChange={(a, b) => onInfoChange(b, a)}
                answer={info?.phone}
                defaultCountryCode={airport_data?.country_code || 'USA'}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged} />
            </>
          )}
        </>
      )}
      </>
    )}
    {orderField === 'default_reported_by' && (
      <>
        {(!!info?.badge_info && enableBadge
          && <PulpoField
              key="badge_id"
              id="badge_id"
              type="string"
              translationID="sms.new.badgeNum"
              title="Badge Number" isRequired
              handleValueChange={(a, b) => onInfoChange(b, a)}
              answer={info?.badge_id}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
              />
        )}
      </>
    )}
      {orderField === 'default_reported_date' && (
        <PulpoField
          key="report_date"
          id="report_date"
          type="date"
          customField
          translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'hazard.report_date'}
          title={(selectedLang && selectedLang !== '' && defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name)
            ? defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name : `${defaultFieldSchema?.[orderField]?.title || 'Reported Date'}`}
          isRequired
          description={defaultFieldSchema?.[orderField]?.description || ''}
          handleValueChange={(a, b) => onInfoChange(b, a)}
          answer={info?.report_date}
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
          fromSMS
          Badging
        />
      )}
      {orderField === 'default_reported_time' && (
          <PulpoField
            key="report_time"
            onlyTime
            customField
            id="report_time"
            type="datetime"
            translationID={defaultFieldSchema?.[orderField] ? 'invalid' : 'hazard.report_time'}
            title={(selectedLang && selectedLang !== '' && defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name)
              ? defaultFieldSchema?.[orderField]?.meta_data?.[selectedLang]?.name : `${defaultFieldSchema?.[orderField]?.title || 'Time'}`}
            isRequired
            description={defaultFieldSchema?.[orderField]?.description || ''}
            handleValueChange={(a, b) => onInfoChange(b, a)}
            answer={info?.report_time}
            showFieldErrors={showFormErrors}
            handleFieldErrorChanged={handleFieldErrorChanged}
            fromSMS
          />
      )}
  </>
);
};

Step1.propTypes = {
  onInfoChange: PropTypes.func.isRequired,
  info: PropTypes.shape({}).isRequired
};

export default Step1;
